import { jsx as _jsx } from "react/jsx-runtime";
import deepmerge from 'deepmerge';
import React, { createContext, useContext, useEffect } from 'react';
import { useAppSelector, withRedux } from '../redux';
const SiteMetadataContext = createContext(undefined);
export const SiteMetadataProvider = withRedux(({ children, siteMetadata }) => {
    const dynamicSiteMetadata = useAppSelector(state => state.site.siteMetadata);
    const [mergedSiteMetadata, setMergedSiteMetadata] = React.useState(siteMetadata);
    useEffect(() => {
        const merged = deepmerge(siteMetadata, dynamicSiteMetadata || {});
        setMergedSiteMetadata(merged);
    }, [dynamicSiteMetadata]);
    return (_jsx(SiteMetadataContext.Provider, { value: mergedSiteMetadata, children: children }));
});
export function useSiteMetadataContext() {
    const context = useContext(SiteMetadataContext);
    if (!context) {
        throw new Error('useSiteMetadata must be used within a SiteMetadataProvider');
    }
    return context;
}
